import { useAppStateStore, useMessagingStore } from '@/stores';

export default async function useNoSavedChangesRouterGuard(beforeEachCallback) {
  const messagingStore = useMessagingStore();
  const appStateStore = useAppStateStore();

  if (messagingStore.showNoSavedChangesModal && messagingStore.unsavedChangesDialog) {
    appStateStore.keepNotificationDialog = true;

    messagingStore.unsavedChangesDialog.callback = () => {
      messagingStore.showNoSavedChangesModal = false;
      beforeEachCallback();
      messagingStore.unsavedChangesDialog.callback = undefined;
      appStateStore.keepNotificationDialog = false;
    };

    messagingStore.unsavedChangesDialog.cancelCallback = () => {
      messagingStore.unsavedChangesDialog.callback = undefined;
      appStateStore.keepNotificationDialog = false;
    };

    messagingStore.showCustomConfirmationDialog(messagingStore.unsavedChangesDialog);
    return;
  }

  await beforeEachCallback();
}
